export default class SortableListPersistence {
  constructor({ objectref, storeKey }) {
    this.objectref = objectref;
    this.store_key = storeKey || `${this.objectref}-cached`;
  }

  setSortKey(sortBy) {
    localStorage.setItem(this.store_key, JSON.stringify(sortBy))
  }

  getSortKey() {
    return JSON.parse(localStorage.getItem(this.store_key))
  }
}
